export function replaceTurkishCharacters(value: string) {
    return value.replace(/İ|I/gi, 'I').replace(/i|ı/gi, 'I')
    .replace(/ç|Ç|c|C/gi, 'C').replace(/ş|Ş|s|S/gi, 'S').replace(/ğ|Ğ|g|G/gi, 'G')
    .replace(/ü|Ü|u|U/gi, 'U').replace(/ö|Ö|o|O/gi, 'O');
}
